var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"label":"Upload image"},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var text = ref.text;
return [_vm._v(" "+_vm._s(text)+" ")]}}]),model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}}),_c('img',{ref:"hiddenImageContainer",staticStyle:{"display":"none"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }